/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { createRoute } from '@gh/builder-shared';
import { DashboardComponent } from './components';
import { DashboardBusinessService } from './resources';

const routes: Routes = [createRoute({
  component: DashboardComponent,
  path: '',
  init: DashboardBusinessService,
})];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderDashboardRoutingModule {
}
